export default __webpack_public_path__ + "assets/images/50ba36984a65b1d0ff3c37ec97042dd5.png";